import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import DummyApi from '../dummyApi';
import _ from 'lodash';
import { toLocalDateTimeStr, toLocalDateWithFormat } from 'src/shared/utils/localDateTime';
import {
  ApprovalDto,
  ApprovalDetailDto,
  FileDetailsInfo,
  DownloadHistoryInfo,
} from './approvalApi';
const FXM_API_ENABLED = config.servers.fxm.enabled;
const FXM_API_URL = config.servers.fxm.url;
export interface ProvisionalApprovalDto extends ApprovalDto {
  startDate: number; // 요청 시작 시간
  endDate: number; // 요청 종료 시간
}
export interface ProvisionalApprovalDetailDto extends ApprovalDetailDto {
  startDate: number;
  endDate: number;
  rightView: string;
  rightEdit: string;
  rightPrintScreen: string;
  rightPrint: string;
  rightSecurePrint: string;
  rightSave: string;
  rightTransfer: string;
  rightClassTransfer: string;
  rightExtract: string;
  rightMacro: string;
  rightConversion: string;
  rightBranch: string;
  rightUnwrap: string;
  uniqueId: string;
  applyType: string;
  period: number;
  permissibleCnt: number;
  fileDetail: FileDetailsInfo;
  downloadHistory: DownloadHistoryInfo[];
}
export interface ProvisionalApprovalDetailEtity extends ProvisionalApprovalDetailDto {
  startDateStr: string;
  endDateStr: string;
  applyDateStr: string;
  updatedTsStr: string;
}
export const toProvisionalApprovalDetailDtoToEntity = (
  dto: ProvisionalApprovalDetailDto
): ProvisionalApprovalDetailEtity => {
  return {
    ...dto,
    startDateStr: dto.startDate > 0 ? toLocalDateWithFormat(dto.startDate, 'YYYY-MM-DD HH:mm') : '',
    endDateStr: dto.endDate > 0 ? toLocalDateWithFormat(dto.endDate, 'YYYY-MM-DD HH:mm') : '',
    applyDateStr: dto.applyDate > 0 ? toLocalDateWithFormat(dto.applyDate, 'YYYY-MM-DD HH:mm') : '',
    updatedTsStr: dto.updatedTs > 0 ? toLocalDateWithFormat(dto.updatedTs, 'YYYY-MM-DD HH:mm') : '',
    progressApprovers: dto.progressApprovers === null ? [] : dto.progressApprovers,
    completeApprovers: dto.completeApprovers === null ? [] : dto.completeApprovers,
  };
};
export type ProvisionalApprovalReqDto = Omit<ProvisionalApprovalDto, 'code'>;
interface ProvisionalApprovalApi {
  find(approvalNo: string): Promise<ProvisionalApprovalDetailEtity>;
  cancel(approvalNo: string): Promise<boolean>;
}
class ProvisionalApprovalServerApi implements ProvisionalApprovalApi {
  async find(approvalNo: string): Promise<ProvisionalApprovalDetailEtity> {
    const resp = await axios.get<ProvisionalApprovalDetailDto>(
      `${FXM_API_URL}/api/provisional/find/${approvalNo}`
    );
    return toProvisionalApprovalDetailDtoToEntity(resp.data);
  }
  async cancel(approvalNo: string): Promise<boolean> {
    const resp = await axios.get<ProvisionalApprovalDetailDto>(
      `${FXM_API_URL}/api/decrypt/cancel/${approvalNo}`
    );
    return true;
  }
}
const provisionalApprovalApi = new ProvisionalApprovalServerApi();
export default provisionalApprovalApi;
